import { useState } from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import MemberEventsHeader from "./MemberEventsHeader";
import MemberEventsBody from "./MemberEventsBody";
import Paginate from "../../../../../Utilities/Paginate";

// This component will hold the latest leads data
const MemberEventsTable = ({ userEvents, totalMemberEvents, open }) => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(30);
    const handleChangePage = (event, newPage) => setPage(newPage);

      const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={`${open ? "show-table" : "hide-table"}`}>
      <h4 className="aggregated-report-count">
        Total Events {totalMemberEvents}
      </h4>
      <TableContainer>
        <Table className="table">
          <MemberEventsHeader />
          <MemberEventsBody 
            userEvents={userEvents}
            page={page}
            rowsPerPage={rowsPerPage} />
        </Table>
      </TableContainer>
      { userEvents.length > rowsPerPage ? 
        <Paginate totalRowCount={userEvents.length} page={page} rowsPerPage={rowsPerPage} handleChange={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} showCorePaginate={true} />
        : null
      }
      <div className="bottom-footer"></div>
    </div>
  );
};

export default MemberEventsTable;
